import { useCallback } from 'react'
import { validateUser, validateBidAmount } from '../utils/validation'

const useBidValidation = ({ isAuthenticated, isVerified, minimumBid, maxBiddingLevel, t, alert }) => {
  const validateBid = useCallback(
    amount => {
      const userValidation = validateUser({ isAuthenticated, isVerified, t })
      if (!userValidation.isValid) {
        alert(userValidation.error, 'danger')
        return false
      }

      const bidValidation = validateBidAmount({ amount, minimumBid, maxBiddingLevel, t })
      if (!bidValidation.isValid) {
        if (bidValidation.error) {
          alert(bidValidation.error, 'danger')
        }
        return false
      }

      return true
    },
    [isAuthenticated, isVerified, minimumBid, maxBiddingLevel, t, alert]
  )

  return validateBid
}

export default useBidValidation
